<template>
    <section class="container mx-auto py-12 px-4">
        <div class="text-center mb-12">
            <h1
                class="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-500 to-green-900 mb-4">
                About Bhawal Sena Club
            </h1>
            <p class="text-lg text-gray-600 max-w-2xl mx-auto mb-6">
                With a glorious 35-year history, Bhawal Sena Club has set a remarkable example of growth and innovation.
                We are dedicated to helping our members achieve their dreams and build a better society.
            </p>
        </div>

        <div class="bg-gradient-to-r from-green-100 via-blue-100 to-purple-100 p-8 rounded-xl shadow-xl mb-12">
            <h2
                class="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-green-600 mb-6">
                Our Philosophy
            </h2>
            <p class="text-xl text-gray-800 mb-6">
                "The dreams of its members are the dreams of the club, and their success is the success of the club."
            </p>
            <p class="text-lg text-gray-700">
                Guided by this philosophy, Bhawal Sena Club extends its support to help every member achieve their goals
                and dreams.
            </p>
        </div>

        <div class="mb-12">
            <h2
                class="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-green-600 mb-6">
                Our Primary Goal
            </h2>
            <p class="text-lg text-gray-700 mb-6">
                The cornerstone of Bhawal Sena Club’s mission is to assist its members in achieving their life goals and
                dreams. Every initiative, plan, and activity of the club is dedicated to this objective.
            </p>
            <div class="grid md:grid-cols-2 gap-8">
                <div
                    class="bg-gradient-to-r from-yellow-100 via-orange-100 to-red-100 p-6 rounded-xl shadow-lg hover:shadow-2xl transition duration-300">
                    <h3 class="text-2xl font-semibold text-gray-800 mb-4">The Bridge to Dreams</h3>
                    <p class="text-gray-700">
                        The club serves as a bridge to its members' dreams by offering training sessions, competitions,
                        workshops, and personal counseling to nurture their talents, skills, and creativity.
                    </p>
                </div>
                <div
                    class="bg-gradient-to-r from-pink-100 via-teal-100 to-green-100 p-6 rounded-xl shadow-lg hover:shadow-2xl transition duration-300">
                    <h3 class="text-2xl font-semibold text-gray-800 mb-4">Motivation and Support</h3>
                    <p class="text-gray-700">
                        Our motto is: "Dream big, move forward, succeed—Bhawal Sena Club will always stand by your
                        dreams." This mindset fosters a supportive environment where every member feels confident to
                        pursue their aspirations.
                    </p>
                </div>
            </div>
        </div>

        <div class="mb-12">
            <h2
                class="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-green-900 mb-6">
                Diverse Paths to Development
            </h2>
            <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                <div
                    class="bg-gradient-to-r from-teal-100 via-blue-100 to-indigo-100 p-6 rounded-xl shadow-lg hover:shadow-2xl transition duration-300">
                    <h3 class="text-2xl font-semibold text-gray-800 mb-4">Promoting Sports</h3>
                    <p class="text-gray-700">
                        Our Multi-Sports Arena hosts competitions, training workshops, and activities aimed at physical
                        and mental development, inspiring youth to embrace sports and discipline.
                    </p>
                </div>
                <div
                    class="bg-gradient-to-r from-yellow-200 via-pink-200 to-red-200 p-6 rounded-xl shadow-lg hover:shadow-2xl transition duration-300">
                    <h3 class="text-2xl font-semibold text-gray-800 mb-4">Social Development</h3>
                    <p class="text-gray-700">
                        We conduct awareness programs, support underprivileged individuals, and launch campaigns to
                        spread ethics, humanity, and peace.
                    </p>
                </div>
                <div
                    class="bg-gradient-to-r from-green-200 via-blue-200 to-purple-200 p-6 rounded-xl shadow-lg hover:shadow-2xl transition duration-300">
                    <h3 class="text-2xl font-semibold text-gray-800 mb-4">Promoting Culture</h3>
                    <p class="text-gray-700">
                        We organize cultural events, art exhibitions, and literary activities to showcase Bangladesh’s
                        heritage and nurture pride in our cultural legacy.
                    </p>
                </div>
                <div
                    class="bg-gradient-to-r from-indigo-100 via-teal-200 to-yellow-100 p-6 rounded-xl shadow-lg hover:shadow-2xl transition duration-300">
                    <h3 class="text-2xl font-semibold text-gray-800 mb-4">Spreading Islamic Ideals</h3>
                    <p class="text-gray-700">
                        We promote the true spirit of Islam and ethical values to establish a just and peaceful society.
                    </p>
                </div>
            </div>
        </div>

        <!-- Conclusion Section -->
        <div class="bg-gradient-to-r from-blue-50 to-purple-100 p-8 rounded-xl shadow-lg">
            <h2
                class="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-green-900 mb-6">
                Conclusion
            </h2>
            <p class="text-xl text-gray-700 mb-6">
                Bhawal Sena Club is more than an organization—it is a platform for realizing dreams. Our primary
                objective is to support our members in achieving their goals and improving their quality of life.
            </p>
            <p class="text-lg text-gray-700">
                "The dreams of Bhawal Sena Club are the dreams of its members. Together, we will move forward, create
                new chapters of success, and build a better society for future generations."
            </p>
        </div>

        <!-- Call to Action -->
        <div class="text-center mt-12">
            <h3
                class="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-green-900 mb-4">
                Join Us Today!
            </h3>
            <p class="text-lg text-gray-700 mb-6">
                Let us dream together, move forward, and achieve new dimensions of success. Stay with Bhawal Sena
                Club—together, we will turn dreams into reality.
            </p>
            <router-link to="/member-register" target="_blank"
                class="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-3 rounded-xl font-semibold hover:bg-gradient-to-l transition duration-300">
                Become a Member
            </router-link>
        </div>
    </section>
</template>

<script>
export default {
    name: 'AboutUs',
};
</script>

<style scoped>
/* Adding shadow effect for hover */
.hover\:shadow-2xl:hover {
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.1);
}
</style>
